/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ShopGetAllReq } from '../models/shop-get-all-req';
import { ShopGetAllResp } from '../models/shop-get-all-resp';

@Injectable({
  providedIn: 'root',
})
export class ShopService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation shopGetAll
   */
  static readonly ShopGetAllPath = '/shop/get-all';

  /**
   * Get all shops
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopGetAll()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopGetAll$Response(params: {
    body: ShopGetAllReq
  }): Observable<StrictHttpResponse<ShopGetAllResp>> {

    const rb = new RequestBuilder(this.rootUrl, ShopService.ShopGetAllPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ShopGetAllResp>;
      })
    );
  }

  /**
   * Get all shops
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `shopGetAll$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopGetAll(params: {
    body: ShopGetAllReq
  }): Observable<ShopGetAllResp> {

    return this.shopGetAll$Response(params).pipe(
      map((r: StrictHttpResponse<ShopGetAllResp>) => r.body as ShopGetAllResp)
    );
  }

  /**
   * Path part for operation shopGetDefaultSync
   */
  static readonly ShopGetDefaultSyncPath = '/shop/get-default-sync';

  /**
   * TODO: Pending move definitions to ref schemas.
   *
   * Get all shops
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shopGetDefaultSync()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopGetDefaultSync$Response(params: {
    body: {
'filters'?: Array<{
'filter'?: string;
'value'?: string;
}>;
}
  }): Observable<StrictHttpResponse<Array<{
'id'?: number;
'uuid'?: string;
'name'?: string;
'module'?: string;
'created_at'?: string;
'updated_at'?: string;
'deleted_at'?: string;
'is_active'?: boolean;
}>>> {

    const rb = new RequestBuilder(this.rootUrl, ShopService.ShopGetDefaultSyncPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<{
        'id'?: number;
        'uuid'?: string;
        'name'?: string;
        'module'?: string;
        'created_at'?: string;
        'updated_at'?: string;
        'deleted_at'?: string;
        'is_active'?: boolean;
        }>>;
      })
    );
  }

  /**
   * TODO: Pending move definitions to ref schemas.
   *
   * Get all shops
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `shopGetDefaultSync$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shopGetDefaultSync(params: {
    body: {
'filters'?: Array<{
'filter'?: string;
'value'?: string;
}>;
}
  }): Observable<Array<{
'id'?: number;
'uuid'?: string;
'name'?: string;
'module'?: string;
'created_at'?: string;
'updated_at'?: string;
'deleted_at'?: string;
'is_active'?: boolean;
}>> {

    return this.shopGetDefaultSync$Response(params).pipe(
      map((r: StrictHttpResponse<Array<{
'id'?: number;
'uuid'?: string;
'name'?: string;
'module'?: string;
'created_at'?: string;
'updated_at'?: string;
'deleted_at'?: string;
'is_active'?: boolean;
}>>) => r.body as Array<{
'id'?: number;
'uuid'?: string;
'name'?: string;
'module'?: string;
'created_at'?: string;
'updated_at'?: string;
'deleted_at'?: string;
'is_active'?: boolean;
}>)
    );
  }

}
